export default __webpack_public_path__ + "static/media/co2.eb1b04f3.png";